import uajs from './module/ua';

(function ($) {
	const ua = uajs();

	$(document).ready(function () {

		// アンカーリンク　自動で共通ヘッダー分の高さを考慮
		$('a').click(function (e) {
			let href = $(this).attr('href');
			if (href.match(/^#/) && $(href).length > 0) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(href).offset().top
				}, 'fast');
			}
		});

	});

})(jQuery);

// lottie.jsアニメ設定
$(function () {
	var graph1 = lottie.loadAnimation({
		container: document.getElementById('graph-01'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-01.json'
	});

	var graph2 = lottie.loadAnimation({
		container: document.getElementById('graph-02'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-02.json'
	});

	var graph3 = lottie.loadAnimation({
		container: document.getElementById('graph-03'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-03.json'
	});

	var graph4 = lottie.loadAnimation({
		container: document.getElementById('graph-04'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-04.json'
	});

	var graph5 = lottie.loadAnimation({
		container: document.getElementById('graph-05'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-05.json'
	});

	var graph6 = lottie.loadAnimation({
		container: document.getElementById('graph-06'),
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: './assets/json/graph-06.json'
	});

	window.addEventListener('scroll', event => {
		var windowHeight = window.innerHeight;
		var targetTop1 = document.getElementById('graph-01').getBoundingClientRect().top;
		var targetTop2 = document.getElementById('graph-02').getBoundingClientRect().top;
		var targetTop3 = document.getElementById('graph-03').getBoundingClientRect().top;
		var targetTop4 = document.getElementById('graph-04').getBoundingClientRect().top;
		var targetTop5 = document.getElementById('graph-05').getBoundingClientRect().top;
		var targetTop6 = document.getElementById('graph-06').getBoundingClientRect().top;

		if (0 < targetTop1 && targetTop1 <= windowHeight - 350) {
			graph1.play();
		}
		if (0 < targetTop2 && targetTop2 <= windowHeight - 350) {
			graph2.play();
		}
		if (0 < targetTop3 && targetTop3 <= windowHeight - 350) {
			graph3.play();
		}
		if (0 < targetTop4 && targetTop4 <= windowHeight - 350) {
			graph4.play();
		}
		if (0 < targetTop5 && targetTop5 <= windowHeight - 350) {
			graph5.play();
		}
		if (0 < targetTop6 && targetTop6 <= windowHeight - 350) {
			graph6.play();
		}
	});
});
